import { Box, Button } from "@mui/material";
import InfoText from "./typographies/InfoText";
import { useState } from "react";

interface Props {
  text: string;
  moreText: string;
  moreMoreText?: string;
}

const ReadMoreInfo = ({ text, moreText, moreMoreText }: Props) => {
  const [readMore, setReadMore] = useState<boolean>(false);
  return (
    <>
      <InfoText text={text} />
      <Box sx={{ marginTop: 2, marginBottom: 2 }}>
        {!readMore && (
          <Button onClick={() => setReadMore(true)} variant="contained">
            LÄS MER
          </Button>
        )}
        {readMore && <InfoText text={moreText} />}
        {readMore && moreMoreText && (
          <Box sx={{ marginTop: 2 }}>
            <InfoText text={moreMoreText} />
          </Box>
        )}
      </Box>
    </>
  );
};

export default ReadMoreInfo;
